import { Pipe, PipeTransform } from '@angular/core';

const HEAD_COUNT = 16;
const HIDE_THRESHOLD = 8;
const TAIL_COUNT = 8;

@Pipe({
  name: 'filenameShortener'
})
export class FilenameShortenerPipe implements PipeTransform {
  transform(name: string): string {
    if (!name) {
      return '';
    }

    const lastDotIndex = name.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return name;
    }

    const nameWithoutExtension = name.substring(0, lastDotIndex);
    const extension = name.substring(lastDotIndex);

    if (nameWithoutExtension.length < HEAD_COUNT + HIDE_THRESHOLD + TAIL_COUNT) {
      return name;
    }

    const startPart = nameWithoutExtension.substring(0, HEAD_COUNT);
    const endPart = nameWithoutExtension.slice(-TAIL_COUNT);

    return `${startPart}…${endPart}${extension}`;
  }
}
